<template>
  <div class=" seced-page w100">
    <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;"><el-button type="warning" plain
        icon="el-icon-download" @click="exportExcel">导出</el-button></div>
    <el-table :data="list" style="width: 100%" :header-cell-style="styleObj" class="mb20"
      :cell-style="{ fontSize: '15px', color: '#666666' }">
      <el-table-column prop="name" label="名称" width="200"></el-table-column>
      <el-table-column prop="num" label="数量"></el-table-column>
      <el-table-column prop="refundNum" label="退款数" />
      <!-- <el-table-column prop="amount" label="单价" /> -->
      <el-table-column prop="payment_channel" label="总金额">
        <template #default="scope">
          {{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column prop="payment_channel" label="退款金额">
        <template #default="scope">
          {{ scope.row.refund }}
        </template>
      </el-table-column>

      <el-table-column prop="payment_channel" label="总收入">
        <template #default="scope">
          {{ (scope.row.amount - scope.row.refund).toFixed(2) }}
        </template>
      </el-table-column>
      <div slot="empty" style="text-align: center;width:100%">
        暂无数据
      </div>
    </el-table>
  </div>
</template>
<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
  props: {
    endTime: {
      default: ''
    },
    startTime: {
      default: ''
    },
  },
  data() {
    return {
      choseArr: [],
      dialogVisible: false,
      styleObj: {
        background: '#F3F3F3',
        color: '#1F3349',
        fontSize: '15px',
        fontWeight: 'normal',
      },
      list: [],
    }
  },
  methods: {
    exportExcel() {
      if (!this.startTime) return this.$message.error('请选择查询时间')
      if (!this.list[0]) return this.$message.error('请搜索后导出')
      let t = [];
      this.list.map(r => {
        let obj = {
          '名称': r.name,
          '数量': r.num,
          '退款数': r.refundNum,
          // '单价':r.amount,
          '总金额': (r.amount),
          '退款': r.refund,
          '总收入': (r.amount - r.refund).toFixed(2)
        }
        t.push(obj)
      })
      // 创建工作簿
      const wb = XLSX.utils.book_new();
      // 将JSON数据转换为工作表
      const ws = XLSX.utils.json_to_sheet(t);
      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
      // 生成Excel文件并下载
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      saveAs(new Blob([wbout], { type: 'application/octet-stream' }), (this.startTime + '-' + this.endTime) + '年卡报表.xlsx');
    },
    resetData() {
      this.api.postUrl('/api/v1/window/statement/yearCard', { startTime: this.startTime, endTime: this.endTime }, { loading: true }).then(res => {
        this.list = res;
      })
    },
    handleSelectionChange(e) {
      this.choseArr = e;
    },
    clear() {
      this.keyword = '';
      this.list = []
    },
    checkSelectable(row, index) {
      return row.status != '-1';
    },
  },
  created() {
    this.keyword = this.$route.query.search ? this.$route.query.search : ''
  }
}
</script>
<style scoped>
.demo-ruleForm {
  width: 400px;
}
</style>